import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

export function AppIconEyeOutline({ size = 20, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        fill={fill}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.001 4.04102C16.4361 4.04117 20.2482 6.69719 21.9387 10.5005C22.3627 11.4544 22.3626 12.5449 21.9387 13.4988C20.2483 17.3023 16.4362 19.9593 12.001 19.9594C7.56553 19.9594 3.75249 17.3024 2.06204 13.4988C1.63824 12.5449 1.6381 11.4544 2.06204 10.5005C3.75253 6.697 7.56561 4.04102 12.001 4.04102ZM12.001 6.37048C8.51926 6.37048 5.52155 8.45394 4.19132 11.4469C4.03501 11.7986 4.03501 12.2019 4.19132 12.5536C5.52162 15.5463 8.51938 17.63 12.001 17.63C15.4825 17.6298 18.4804 15.5464 19.8106 12.5536C19.9669 12.2019 19.9668 11.7985 19.8106 11.4469C18.4804 8.45395 15.4825 6.37063 12.001 6.37048ZM13.7469 11.9996C13.7467 11.0349 12.9646 10.2525 11.9998 10.2525C11.0352 10.2527 10.2529 11.035 10.2527 11.9996C10.2527 12.9644 11.0351 13.7466 11.9998 13.7467C12.9647 13.7467 13.7469 12.9645 13.7469 11.9996ZM16.0764 11.9996C16.0764 14.2511 14.2512 16.0762 11.9998 16.0762C9.74854 16.076 7.92325 14.251 7.92325 11.9996C7.92345 9.74851 9.74867 7.92326 11.9998 7.92308C14.2511 7.92308 16.0762 9.7484 16.0764 11.9996Z"
      />
    </Svg>
  )
}
